module.exports = __webpack_public_path__ + "static/media/message03.03f4bf29.png";